<template>
  <div class="pa-4">
    <div style="font-size: 1em;text-align: center;"> 
        <div style="text-align: left;">
          <img style="width:60px;height:60px;object-fit:cover;border-radius:50%;" :src="userFile(this.$store.state.academyImage)" />
        </div>
        <div style="text-align:left;font-size:0.8em" v-html="waiverContents">
        </div>
        <div style="text-align:left;margin-top:50px">
          <table width="100%">
            <tr>
              <td width="70%">
                <div style="width: 400px;border-top: 1px black solid">
                  {{$t('message.name_student')}}
                </div>
              </td>
              <td>
                <div style="width: 200px;border-top: 1px black solid">
                  {{$t('message.date')}}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="width: 400px;border-top: 1px black solid; margin-top: 30px">
                  {{$t('message.name_guardian')}}
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <div style="width: 400px;border-top: 1px black solid; margin-top: 30px">
                  {{$t('message.signature_student_guardian')}}
                </div>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
  </div>
</template>

<script>
import Api from '@/services/Api';

export default {
  data() {
    return {
      lang: this.$route.params.lang,
      id: this.$route.params.id,
      waiverContents: this.$t('message.loading'),
    };
  },
  components: {
  },
  created() {
    if(this.id){
      console.log('Nothing to do here yet.')
    }else{
      Api().get('admins/academy/'+this.$store.state.selectedAcademy+'/waivers')
        .then(response => {
          const data = response.data;
          for(const w of data){
            if(w.lang == this.lang){
              this.waiverContents = w.agreement
              window.print();
            }
          }
        });
    }
  },
  watch: {

  },
  methods: {
  }
};
</script>

<style scoped>
.waiver{
  font-family: 'Bradley Hand';
  color: black
}
</style>